import { render, staticRenderFns } from "./ConfiguratorPage.vue?vue&type=template&id=670007d6&"
import script from "./ConfiguratorPage.vue?vue&type=script&lang=js&"
export * from "./ConfiguratorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('670007d6')) {
      api.createRecord('670007d6', component.options)
    } else {
      api.reload('670007d6', component.options)
    }
    module.hot.accept("./ConfiguratorPage.vue?vue&type=template&id=670007d6&", function () {
      api.rerender('670007d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/ConfiguratorPage.vue"
export default component.exports